export const RUN_ABORT_INITIALIZE = 'PAGE_TASK_RUN_ABORT_INITIALIZE';

export function initialize() {
  return {
    type: RUN_ABORT_INITIALIZE
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/tasks/RunAbort.js